const styles = {
  p: 3,
  top: '50%',
  left: '50%',
  boxShadow: 24,
  outline: 'none',
  borderRadius: 4,
  position: 'absolute',
  transform: 'translate(-50%, -50%)',
  bgcolor: t => t.palette.background.default,
  width: {
    lg: 540, md: 540, sm: 500, xs: 360,
  },
};

export { styles };
